import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-row w-full mt-2 mb-4 flex-wrap gap-3 ml-2 text-xs" }
const _hoisted_2 = ["onClick", "delay"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transferChannelOptions, (option, idx) => {
      return _withDirectives((_openBlock(), _createElementBlock("span", {
        key: option.channel,
        onClick: _withModifiers(($event: any) => (_ctx.requestDestination(option)), ["prevent"]),
        delay: idx * 250,
        class: "cursor-pointer border-2 border-superagent hover:bg-gray-50 transition-colors rounded-xl px-3 py-2 w-fit inline"
      }, [
        _createTextVNode(_toDisplayString(option.channelDescription), 1)
      ], 8, _hoisted_2)), [
        [_directive_motion_pop]
      ])
    }), 128))
  ]))
}